module.exports = __webpack_public_path__ + "static/media/home_avatar8.ec72c541.png";